import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";

const CocktailsDrinks50Off2026 = () => {
  const { t, i18n } = useTranslation();

  return (
    <CocktailsDrinksDiv>
      <Hero
        bgImage="promotions/dining/50-percent-off-cocktails-and-drinks-2026/50__Off_Drinks_Header_1600x542px.jpg"
        buttonSettings={null}
        image={`promotions/dining/50-percent-off-cocktails-and-drinks-2026/50__Off_Drinks-Logo_2400px-${i18n.language}.png`}
        darkenBg={0}
        description={t("diningPromos.cocktailsDrinks50Off2026.hero.title")}
        descriptionBgColor="#0000004d"
      />
      <EventFinished
        scheduleKeyName="cocktailsDrinks50Off2026"
        eventType="promotions"
      />
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.cocktailsDrinks50Off2026.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t("diningPromos.cocktailsDrinks50Off2026.content.description")}
              </ReactMarkdown>
            </Col>
            <Col className="pt-md-4">
              <ResponsiveImage
                src={`promotions/dining/50-percent-off-cocktails-and-drinks-2026/50__Off_Drinks-homepage-carousel-1368x1200px.jpg`}
                alt={t("diningPromos.cocktailsDrinks50Off2026.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.cocktailsDrinks50Off2026.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </CocktailsDrinksDiv>
  );
};

const CocktailsDrinksDiv = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
    max-width: 1100px;
    word-wrap: break-word;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #e70a02;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background: rgba(0, 0, 0, 0.5);
  }
  height: auto;
  width: 100%;
  text-align: left;
  .p_1 strong {
    white-space: nowrap;
  }
  .desc strong {
    color: #d1a55d;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export default CocktailsDrinks50Off2026;
